// extracted by mini-css-extract-plugin
export default {"pagination_button":"Statistic_pagination_button__+JDgA"};